import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles'
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
// Removing Formatted Message and defineMessages for the time being
// Import { injectIntl, FormattedMessage, defineMessages } from 'react-intl';
import Default, { Mobile } from '../../utils/mediaQueries';
import School from '../../components/School';
import Loader from '../../components/Loader';
/* eslint-disable import/no-named-as-default */
import Button from '../../components/Button';
import Mapbox from '../../components/Mapbox';
import messages from '../../locale/messages';
import classNames from 'classnames';
import style from './SchoolDetail.scss';
import { getSchools, getWaitlistsSubmissionsState } from '../../actions/schools';
import studentInfo from '../../actions/studentInfo';
import { getStudent, getStudentPrograms, getStudentApplications } from '../../actions/student';
import history from '../../history';
import schoolsToMarker from '../../services/schoolsToMarker';
import { processNameToShortCode, customisedIntlFormatMessage } from '../../utils/helpers';
import HomeIcon from '../../components/icons/Home';
import CloseIcon from '../../components/icons/Close';
import { getFilters } from '../../actions/filters';
import FilterSelect from '../../components/FilterSelect';
import SearchField from '../../components/SearchField';
import GOATSearchContainer from '../../containers/GOATSearchContainer';
import { addParameterAndSearch } from '../../actions/addParameter';
import { getSchoolsAutocomplete } from '../../actions/autocomplete';
import SearchAndFilter from '../../components/SearchAndFilter';
import analytics from '../../services/analytics';
import { withRtl } from '../../components/hoc';

class SchoolDetail extends Component {
  static defaultProps = {
    normalSchools: null,
    isRtl: false
  };

  static propTypes = {
    getSchools: PropTypes.func.isRequired,
    getStudent: PropTypes.func.isRequired,
    getStudentApplications: PropTypes.func.isRequired,
    getStudentPrograms: PropTypes.func.isRequired,
    schools: PropTypes.shape({
      name: PropTypes.string,
      normalSchools: PropTypes.shape().isRequired,
      loaded: PropTypes.bool.isRequired,
      loading: PropTypes.bool.isRequired,
    }).isRequired,
    normalSchools: PropTypes.shape(),
    intl: PropTypes.shape({
      locale: PropTypes.string,
    }).isRequired,
    studentInfo: PropTypes.func.isRequired,
    user: PropTypes.shape({
      applicationId: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
      admissionProcess: PropTypes.string,
    }).isRequired,
    pathname: PropTypes.string.isRequired,
    isRtl: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
    };

    // sk: I can't believe we can't get these in as URL params from the routes?
    const parts = props.pathname.split('/');
    this.dbn = parts.pop() || parts.pop();
    this.dbn = this.dbn.toUpperCase();

    this.backToLink = parts.join('/');
    this.processName = parts.pop();
    this.admissionProcess = processNameToShortCode({ processName: this.processName });
    const urlParams = new URLSearchParams(window.location.search);
    this.showSavedProgramsOnly = urlParams.get('saves');
  }

  ensureSchoolLoaded = () => {
    const { normalSchools, loaded } = this.props.schools;
    const cachedSchool = loaded && Object.values(normalSchools?.entities?.school || {})
      .find(s => s.school?.dbn === this.dbn);
    if (!cachedSchool) {
      this.props.getSchools({ extra: `/${this.dbn}`, processName: `${this.processName}` });
    }
  };

  async componentDidMount() {
    const { user } = this.props;
    const { applicationId } = this.props.user;
    await this.props.getFilters({ processName: `${this.processName}` });
    this.ensureSchoolLoaded();

    if (applicationId) {
      this.props.studentInfo(applicationId);
      //this.props.getStudentPrograms(applicationId);
      this.props.getStudentApplications(applicationId);
      this.admissionProcess = user.admissionProcess;
      if (user.isWaitlist) {
        this.props.getWaitlistsSubmissionsState();
      }
    }
  }

  componentDidUpdate(nextProps) {
    if (nextProps.intl.locale !== this.props.intl.locale) {
      this.props.getSchools({ extra: `/${this.dbn}` });
    }

    if (nextProps.pathname !== this.props.pathname) {
      const parts = this.props.pathname.split('/');
      this.dbn = (parts.pop() || parts.pop()).toUpperCase();
      this.props.getSchools({ extra: `/${this.dbn}`, processName: `${this.processName}` });
    }
  }

  // Example of non-binding
  /*
    TODO: write why this is what it is
  */

  getSchools = () => {
    const { normalSchools, loading, loaded } = this.props.schools;
    const { user } = this.props;
    const { applicationId } = user;
    let load = null;
    let loggedIn = false;
    if (applicationId !== '') {
      loggedIn = true;
    }

    if (loggedIn) {
      this.admissionProcess = user.admissionProcess;
    }

    if (loading) {
      load = (
        <li className={style.listItem}>
          <Loader />
        </li>
      );
      return load;
    } else if (loaded) {
      if (!normalSchools?.result?.length) {
        return (
          <div className={style.noResults}>
            <h3>
              <FormattedMessage {...messages.generalStringNoResultsFound} />
            </h3>
          </div>
        );
      }

      let school = Object.values(normalSchools.entities.school).find(s => s.school?.dbn === this.dbn);
      if (!school) {
        return <li className={style.listItem}><Loader /></li>;
      }
      
      return (
        <ul className={style.list}>
          <li key="detail" className={style.listItem}>
            <School
              {...school}
              loggedIn={loggedIn}
              showDetails
              headerOpen
              applicationId
              onClick={() => { }}
              programClick={this.programClick}
              programOpen={this.state.currentProgramId}
              user={user}
              admissionProcess={this.admissionProcess}
            />
          </li>
        </ul>
      );
    }
    return load;
  };

  getMarkers = () => {
    const { normalSchools, loading, loaded } = this.props.schools;
    let markers = [];
    if (loading) {
      return markers;
    } else if (loaded && normalSchools?.result?.length > 0 && Object.values(normalSchools.entities?.school).filter(item => item.school.dbn == this.dbn).length > 0) {
      markers = schoolsToMarker(normalSchools, [this.dbn], this.admissionProcess);
    }
    return markers;
  };

  programClick = id => {
    // this.setState({
    //   currentProgramId: id,
    // });
  };

  backToList = () => {
    let backURL = this.backToLink + "?filters_applied=1";
    if (this.showSavedProgramsOnly)
      backURL = this.appendSavesURL(backURL);
    history.push(backURL);
  };

  mapPlaceholder = () => {
    this.click();
  };

  mapClick = () => { };

  handleApplyFilter = ({ optionGroups }) => {
    const { dispatch } = this.props;
    dispatch(addParameterAndSearch(optionGroups));
    let backURL = this.backToLink + "?filters_applied=1";
    if (this.showSavedProgramsOnly)
      backURL = this.appendSavesURL(backURL);
    history.push(backURL);
  };

  handlePlaceChange = (prediction) => {
    let backURL = this.backToLink + "?filters_applied=1&prediction=" + JSON.stringify(prediction);
    if (this.showSavedProgramsOnly)
      backURL = this.appendSavesURL(backURL);
    history.push(backURL);
  }

  handleClearAddress = () => {
    let backURL = this.backToLink + "?filters_applied=1&clear_address=1";
    if (this.showSavedProgramsOnly)
      backURL = this.appendSavesURL(backURL);
    history.push(backURL);
  }

  getFilters = () => {
    const { filters, filtersLoading, filtersLoaded } = this.props.filters;
    let filtersLoad = null;
    if (filtersLoading) {
      filtersLoad = (
        <li className={style.listItem}>
          <Loader />
        </li>
      );
      return filtersLoad;
    } else if (filtersLoaded) {
      filtersLoad = (
        <div className={`${style.filters} exclude-print`}>
          {filters.map(filter => {
            const allOptions = filter.optionGroups.map(({ options }) => options);
            const selected = _.flattenDeep(allOptions)
              // eslint-disable-next-line no-shadow
              .map(({ selected }) => selected)
              .filter(n => n);

            return (
              <FilterSelect
                key={filter.label}
                label={filter.label}
                optionGroups={filter.optionGroups}
                apply={this.handleApplyFilter}
                reset={this.handleApplyFilter}
                selected={selected.length}
                admissionProcess={this.admissionProcess}
              />
            );
          })}
        </div>
      );
    }
    return filtersLoad;
  };

  showAutocompleteSchoolDetail = async string => {
    const { schools, dispatch } = this.props;
    const { autocompleteSchools, autocompleteSchoolsDbn } = schools.autocomplete;
    const dbn = autocompleteSchoolsDbn[autocompleteSchools.indexOf(string)];
    analytics({
      eventLabel: 'autocompleteSchoolClick',
      dataDictionary: {
        schoolDbn: `${dbn}`,
        schoolName: `${string}`,
        loggedIn: this.props.user.applicationId ? true : false,
      },
    });

    await dispatch(
      getSchools({
        extra: `/${dbn}`,
        isAutoComplete: true,
        processName: this.processName,
      }),
    );
    let { pathname } = history.location;
    if (pathname.substr(-1) === '/') {
      pathname = pathname.substr(0, pathname.length - 1);
    }
    const locale = pathname.split('/')[1];
    let schoolPath;
    if (this.props.user.applicationId) {
      schoolPath = `/${locale}/dashboard/${this.props.user.applicationId}/schools/${dbn}/`;
    } else {
      schoolPath = `/${locale}/schools/${this.processName}/${dbn}/`;
    }
    
    if (this.showSavedProgramsOnly)
      history.push(`${schoolPath}?saves=${this.showSavedProgramsOnly}`);
    else
      history.push(schoolPath);
  };

  handleSearchfieldAutocomplete = _.debounce(string => {
    const {
      dispatch,
      schools: { optionsDict: options },
    } = this.props;
    const { latLng } = this.state;
    const urlParams = new URLSearchParams(window.location.search);
    if(urlParams.get('saves') == '1'){
      options['saved_programs'] = ['1'];
    }
    dispatch(
      getSchoolsAutocomplete({
        query: string,
        latLng,
        options,
        processName: this.processName,
      }),
    );
  }, 1000);

  appendSavesURL = (url) => {
    return url + '&saves=' + this.showSavedProgramsOnly
  }

  getAddressAutocomplete = () => {
    const { user, intl } = this.props;
    const userInfo = user.loggedOutUser;
    const { applicationId } = user;
    const { autocompleteSchools } = this.props.schools.autocomplete;
    let searchBarHeader;
    if (user.isPK || user.is2K || user.is3K) {
      searchBarHeader = messages.generalStringSearchAllPrograms;
    } else {
      searchBarHeader = messages.generalStringSearchAllSchoolsAndPrograms;
    }
    return (
      <Fragment>
        {!applicationId &&
          <div className={`${style.addressAutocompleteContainer} exclude-print`}>
            <div className={style.homeIconContainer}>
              <HomeIcon size={25} fill="#052B52" />
            </div>
            <GOATSearchContainer
              placeholder={customisedIntlFormatMessage(intl, messages.generalStringYourChildsAddress)}
              ariaLabel={customisedIntlFormatMessage(intl, messages.generalStringYourChildsAddress)}
              onPlaceChange={this.handlePlaceChange}
              // handlePlaceChangeGooglePlaces={this.handlePlaceChangeGooglePlaces}
              hidden={userInfo.set}
            />
            {userInfo.set && (
              <div className={style.userAddress}>
                <span>{userInfo.formattedAddress}</span>
                <div className={style.clearAddressWrapper}>
                  <CloseIcon
                    size={12}
                    fill="#024cbc"
                    onClick={this.handleClearAddress}
                    aria-label={customisedIntlFormatMessage(intl, messages.generalStringClearAddress)}
                  />
                </div>
              </div>
            )}
          </div>
        }
        {applicationId &&
          <div className={`${style.pageLabel} exclude-print`}>
            <i className="icon-Search" role="presentation" />
            <h1>
              <FormattedMessage {...searchBarHeader} />
            </h1>
          </div>
        }
        <SearchField
          onChangeValue={this.handleSearchfieldAutocomplete}
          onClick={this.showAutocompleteSchoolDetail}
          placeholder={messages.searchfieldPlaceholderSchools}
          autocomplete
          onSearch={this.handleApplyFilter}
          items={autocompleteSchools}
          user={userInfo}
          display={this.state.string || this.props.schools.optionsDict.search && this.props.schools.optionsDict.search[0]}
        />
        {this.getFilters()}
      </Fragment>
    );
  };

  handleToggleMapForMobileView = ({ isOpen }) => {
    this.setState({
      ...this.state,
      mobileMapIsOpen: isOpen,
    });
  };

  handleApplyFilters = ({ filters }) => {
    const { dispatch } = this.props;
    const realOptionGroups = [];
    filters.map(({ optionGroups }) =>
      optionGroups.map(item => {
        realOptionGroups.push(item);
        return item;
      }),
    );

    dispatch(addParameterAndSearch(realOptionGroups));
    let backURL = this.backToLink + "?filters_applied=1";
    if (this.showSavedProgramsOnly)
      backURL = this.appendSavesURL(backURL);
    history.push(backURL);
  };

  render() {
    const mapProps = {
      ...this.props,
      markers: this.getMarkers(),
    };
    const { intl, user } = this.props;
    const { applicationId } = user;
    const isLoggedIn = applicationId ? true : false;
    const { filters } = this.props.filters;
    const { mobileMapIsOpen } = this.state;
    const userInfo = user.loggedOutUser;
    const { autocompleteSchools } = this.props.schools.autocomplete;
    const sidebarClasses = [style.sidebar, style.sidebarLoggedOut];
    const mapClasses = [style.map];
    if (mobileMapIsOpen) {
      sidebarClasses.push(style.sidebarMapIsClicked);
      mapClasses.push(style.mapMapIsClicked);
    }

    let loginAlertForAffiliatedSchools;
    if (this.admissionProcess == 'SR' && !isLoggedIn) {
      loginAlertForAffiliatedSchools = (
        <div className={style.alertBox}>
          <span className={style.alertBoxText}>{customisedIntlFormatMessage(intl, messages.loginAlertForAffiliatedSchoolsMessage)}</span>
        </div>
      );
    }

    return (
      <main className={style.root} role="presentation">
          <Mobile>
            <SearchAndFilter
              filters={filters}
              toggleMap={this.handleToggleMapForMobileView}
              mapIsOpen={mobileMapIsOpen}
              apply={this.handleApplyFilters}
              searchfieldItems={autocompleteSchools}
              searchfieldOnClick={this.showAutocompleteSchoolDetail}
              searchfieldOnSearch={this.handleApplyFilter}
              searchfieldOnChangeValue={this.handleSearchfieldAutocomplete}
              user={userInfo}
              handlePlaceChange={this.handlePlaceChange}
              handleClearAddress={this.handleClearAddress}
              display={this.state.string || this.props.schools.optionsDict.search && this.props.schools.optionsDict.search[0]}
              isLoggedIn={isLoggedIn}
            />
          </Mobile>
          <div className={style.flexRoot}>
            <div className={classNames(...sidebarClasses)} >
              {loginAlertForAffiliatedSchools}
              <Default>{this.getAddressAutocomplete()}</Default>
              <Button
                customClass="exclude-print"
                onClick={this.backToList}
                iconLeft="arrow-left"
                aria-label={customisedIntlFormatMessage(this.props.intl, messages.generalStringBackToList)}
                label={customisedIntlFormatMessage(this.props.intl, messages.generalStringBackToList)}
                iconColor="#4ee4b3"
                full
                large
              />
              {this.getSchools()}
            </div>
            <div className={classNames(...mapClasses)}  >
              <Default>
                <Mapbox {...mapProps} />
              </Default>
              <Mobile>
                <Mapbox {...mapProps} mobile />
              </Mobile>
            </div>
          </div>
      </main>
    );
  }
}

const mapState = ({ schools, filters, user }) => ({ schools, filters, user });

const mapDispatch = {
  getSchools,
  studentInfo,
  getStudent,
  getFilters,
  getStudentPrograms,
  getStudentApplications,
  getWaitlistsSubmissionsState,
};

SchoolDetail.propTypes = {
  intl: PropTypes.shape().isRequired,
};

// We use the injectIntl Higher Order Component (HOC) to make sure the component updates
// Read more about that here https://github.com/yahoo/react-intl/issues/371 and
// https://github.com/yahoo/react-intl/wiki/API#injectintl
export default injectIntl(
  connect(
    mapState,
    mapDispatch,
  )((withRtl(style))(withStyles(style)(SchoolDetail))),
);
